import { SVGProps } from 'react';

const AspiraNeutral = ({ props, size = 64 }: { props?: SVGProps<SVGSVGElement>; size?: string | number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 64 64" fill="none" {...props}>
    <rect width="64" height="64" fill="#161616" rx="32" />
    <path
      fill="#888"
      fillRule="evenodd"
      d="M25.262 30.568c-3.39 7.28-6.42 13.643-6.732 14.143-.571.91-1.353 1.435-2.142 1.435-.222 0-.388.112-.388.26 0 .22.411.26 2.59.26 2.073 0 2.59-.047 2.59-.238 0-.131-.25-.285-.556-.343-.424-.08-.553-.197-.548-.499.004-.217 1.247-3.011 2.762-6.21l2.755-5.814 4.96-.044 4.961-.045 2.729 5.772c1.5 3.175 2.728 5.986 2.728 6.247 0 .36-.11.5-.462.583-.255.06-.463.217-.463.35 0 .2.703.242 3.977.242 3.412 0 3.977-.037 3.977-.26 0-.15-.166-.26-.388-.26-.684 0-1.666-.557-2.119-1.2-.241-.343-2.572-5.114-5.179-10.604l-6.41-13.495c-1.435-3.019-1.728-3.514-2.075-3.514-.358 0-1.107 1.51-6.567 13.234Zm4.934-6.978c-.147.33-1.112 2.405-2.145 4.61-1.032 2.207-1.878 4.062-1.878 4.123 0 .061 1.957.111 4.347.111 2.391 0 4.347-.035 4.347-.078 0-.094-4.044-8.755-4.254-9.113-.112-.189-.216-.103-.416.348Z"
      clipRule="evenodd"
    />
  </svg>
);

export default AspiraNeutral;
